<template>
  <div class="mis-precios">
    <div class="container">
      <section class="pedido-steps">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link to="/pricing-home">
                <img :src="require('../../../assets/img/backspace.svg')" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h5 class="pull-left" title="Ajuda sobre o histórico de preços">
                {{ $t('pricing.mprecios') }}
              </h5>
              <router-link to="/pricing-home">
                <img class="d-none d-sm-block" :src="require('../../../assets/img/backspace.svg')">
              </router-link>
            </div>
          </div>
        </div>

        <div class="filters">
          <form class="form-filter">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterId') }}</label>
                  <input type="text" v-model="filterId" class="form-control" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterDist') }}</label>
                  <input type="text" v-model="filterDistribuidor" class="form-control" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterNameDist') }}</label>
                  <input type="text" v-model="filterNameDistribuidor" class="form-control" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterPlant') }}</label>
                  <input type="text" v-model="filterPlanta" class="form-control" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterStartDate') }}</label>
                  <input type="date" ref="inputFechaInicio" @focus="abrirCalendario" v-model="filterStartDate" class="form-control" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterEndDate') }}</label>
                  <input type="date" ref="inputFechaFin" @focus="abrirCalendarioFin" v-model="filterEndDate" class="form-control" />
                </div>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterCreationDate') }}</label>
                  <input type="date" ref="inputFechaCreacion" @focus="abrirCalendarioCreacion" v-model="filterCreationDate" class="form-control" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterState') }}</label>
                  <select v-model="filterEstado" class="form-control">
                    <option value="">{{ $t('pricing.mis_precios.filterState1') }}</option>
                    <option
                      v-for="estado in uniqueEstados"
                      :key="estado.value"
                      :value="estado.value"
                    >
                      {{ estado.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.mis_precios.filterProfit') }}</label>
                  <select v-model="filterProfit" class="form-control">
                    <option value="">{{ $t('pricing.mis_precios.filterProfit1') }}</option>
                    <option v-for="profit in uniqueProfits" :key="profit" :value="profit">{{ profit }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row justify-content-end">
              <div class="next-btn">
                <a @click="resetFilters" href="javascript:void(0)" class="btn-white">{{ $t('global.btn_clean') }}</a>
                <a href="javascript:void(0)" @click="buscar" class="btn-green" :class="{ disabled: isLoading }">
                  {{ isLoading ? $t('global.btn_searching') : $t('global.btn_search') }}
                </a>
              </div>
            </div>
          </form>
        </div>

        <div class="table-section">
          <h3>{{ $t('pricing.mis_precios.subtitle') }}</h3>
          <div v-if="isLoading" class="spinner-cell">
            <div class="spinner"></div>
          </div>

          <div class="table-responsive">
            <table class="prices-table d-none d-sm-table">
              <thead>
                <tr>
                  <th>{{ $t('pricing.mis_precios.id') }}</th>
                  <th>{{ $t('pricing.mis_precios.dist') }}</th>
                  <th>{{ $t('pricing.mis_precios.ndist') }}</th>
                  <th>{{ $t('pricing.mis_precios.plant') }}</th>
                  <th>{{ $t('pricing.mis_precios.startDate') }}</th>
                  <th>{{ $t('pricing.mis_precios.endDate') }}</th>
                  <th>{{ $t('pricing.mis_precios.creationDate') }}</th>
                  <th>{{ $t('pricing.mis_precios.state') }}</th>
                  <th>{{ $t('pricing.mis_precios.profit') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in this.precios" :key="index" @click="openModalWithDetails(item)" style="cursor: pointer;">
                  <td>{{ item.idrfp }}</td>
                  <td>{{ item.id_distribuidor }}</td>
                  <td>{{ item.name_distribuidor }}</td>
                  <td>{{ item.planta }}</td>
                  <td>{{ formatDate(item.start_date) }}</td>
                  <td>{{ formatDate(item.end_date) }}</td>
                  <td>{{ item.creation_date }}</td>
                  <td>
                    <span
                      :class="{
                        'tag': true,
                        'tag-pricing': item.estado === 'pricing',
                        'tag-sales': item.estado === 'sales',
                        'tag-finance': item.estado === 'finance',
                        'tag-final': item.estado === 'final_approval',
                        'tag-aprobado': item.estado === 'aprobado',
                        'tag-parcial': item.estado === 'parcial',
                        'tag-rechazado': item.estado === 'rechazado' || item.estado === 'vencido'
                      }"
                    >
                      {{ getEstadoLabel(item.estado) }}
                    </span>
                  </td>
                  <td :class="item.state === 'VALID' ? 'state-valid' : 'state-invalid'">
                    <span class="state-icon">
                      <span v-if="item.state === 'VALID'">✅</span>
                      <span v-else>❌</span>
                    </span>
                    {{ item.state }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              class="d-block d-sm-none mobile-card-wrapper"
              v-for="(item, index) in this.precios"
              :key="'mobile-' + index"
            >
              <table
                class="bg-white pedidosTableMobile"
                @click="openModalWithDetails(item)"
                style="cursor: pointer;"
              >
                <tr><th>{{ $t('pricing.mis_precios.id') }}</th><td>{{ item.idrfp }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.dist') }}</th><td>{{ item.id_distribuidor }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.ndist') }}</th><td>{{ item.name_distribuidor }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.plant') }}</th><td>{{ item.planta }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.startDate') }}</th><td>{{ formatDate(item.start_date) }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.endDate') }}</th><td>{{ formatDate(item.end_date) }}</td></tr>
                <tr><th>{{ $t('pricing.mis_precios.creationDate') }}</th><td>{{ item.creation_date }}</td></tr>
                <tr>
                  <th>{{ $t('pricing.mis_precios.state') }}</th>
                  <td>
                    <span
                      :class="{
                        'tag': true,
                        'tag-pricing': item.estado === 'pricing',
                        'tag-sales': item.estado === 'sales',
                        'tag-finance': item.estado === 'finance',
                        'tag-final': item.estado === 'final_approval',
                        'tag-aprobado': item.estado === 'aprobado',
                        'tag-parcial': item.estado === 'parcial',
                        'tag-rechazado': item.estado === 'rechazado' || item.estado === 'vencido'
                      }"
                    >
                      {{ getEstadoLabel(item.estado) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('pricing.mis_precios.profit') }}</th>
                  <td :class="item.state === 'VALID' ? 'state-valid' : 'state-invalid'">
                    <span class="state-icon">
                      <span v-if="item.state === 'VALID'">✅</span>
                      <span v-else>❌</span>
                    </span>
                    {{ item.state }}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12 d-flex align-items-center flex-wrap justify-content-between">
              <div class="d-flex gap-2 mb-2">
                <button v-if="isPricingCoord" class="btn-green" @click="descargarPrecios" :disabled="isDownloading">
                  {{ isDownloading ? $t('global.btn_downloading') : $t('global.btn_download') }}
                </button>
              </div>

              <nav v-if="totalPages > 1">
                <ul class="pagination mb-0">
                  <li class="page-item" :class="{ disabled: page === 1 }">
                    <a class="page-link" href="#" @click.prevent="changePage(page - 1)">‹</a>
                  </li>
                  <li class="page-item" v-for="p in visiblePageNumbers" :key="p" :class="{ active: page === p }">
                    <a class="page-link" href="#" @click.prevent="changePage(p)">{{ p }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: page === totalPages }">
                    <a class="page-link" href="#" @click.prevent="changePage(page + 1)">›</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

        </div>
      <!-- Modal RFP -->
      <div v-if="selectedRfp" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <div class="close-button-container">
            <button class="close-button" @click="closeModal">×</button>
          </div>
          <h2>RFP #{{ selectedRfp.idrfp }}</h2>
          <ul>
            <li><strong>{{ $t('pricing.mis_precios.vendor') }}:</strong> {{ selectedRfp.id_vendedor }}</li>
            <li><strong>{{ $t('pricing.mis_precios.plant') }}:</strong> {{ selectedRfp.planta }}</li>
            <li><strong>{{ $t('pricing.mis_precios.dist') }}:</strong> {{ selectedRfp.id_distribuidor }} - {{ selectedRfp.name_distribuidor }}</li>
            <li><strong>{{ $t('pricing.mis_precios.incoterm') }}:</strong> {{ selectedRfp.incoterm }}</li>
            <li><strong>{{ $t('pricing.mis_precios.invoice') }}:</strong> {{ selectedRfp.invoice_mode }}</li>
            <li><strong>{{ $t('pricing.mis_precios.startDate') }}:</strong> {{ formatDate(selectedRfp.start_date) }}</li>
            <li><strong>{{ $t('pricing.mis_precios.endDate') }}:</strong> {{ formatDate(selectedRfp.end_date) }}</li>
            <li>
              <strong>Estado: </strong>
              <span
                :class="{
                  'tag': true,
                  'tag-pricing': selectedRfp.estado === 'pricing',
                  'tag-sales': selectedRfp.estado === 'sales',
                  'tag-finance': selectedRfp.estado === 'finance',
                  'tag-aprobado': selectedRfp.estado === 'aprobado',
                  'tag-parcial': selectedRfp.estado === 'parcial',
                  'tag-rechazado': selectedRfp.estado === 'rechazado' || selectedRfp.estado === 'vencido'
                }"
              >
                {{
                  selectedRfp.estado === 'pricing' ? 'PENDIENTE PRICING' :
                  selectedRfp.estado === 'sales' ? 'PENDIENTE SALES' :
                  selectedRfp.estado === 'finance' ? 'PENDIENTE FINANCE' :
                  selectedRfp.estado === 'aprobado' ? 'APROBADO' :
                  selectedRfp.estado === 'parcial' ? 'PARCIAL' :
                  selectedRfp.estado === 'rechazado' ? 'RECHAZADO' :
                  selectedRfp.estado === 'vencido' ? 'VENCIDO' :
                  selectedRfp.estado
                }}
              </span>
            </li>
            <li><strong>{{ $t('pricing.mis_precios.fleteLb') }}:</strong> {{ selectedRfp.costo_envio_lb }}</li>
            <li><strong>{{ $t('pricing.mis_precios.fleteKg') }}:</strong> {{ selectedRfp.costo_envio_kg }}</li>
            <li><strong>{{ $t('pricing.mis_precios.delivery') }}:</strong> {{ selectedRfp.delivery }}</li>
          </ul>

          <!-- Sección de Tabla de datos -->
          <div class="modal-product-table-container">
            <table class="modal-product-table">
              <thead>
                <tr>
                  <th><input type="checkbox" v-model="selectAll" @change="toggleAll" /></th>
                  <th>{{ $t('pricing.mis_precios.codSap') }}</th>
                  <th>{{ $t('pricing.mis_precios.sku') }}</th>
                  <th>{{ $t('pricing.mis_precios.precioUsdKg') }}</th>
                  <th>{{ $t('pricing.mis_precios.precioUsdCaja') }}</th>
                  <th>{{ $t('pricing.mis_precios.costoKg') }}</th>
                  <th>{{ $t('pricing.mis_precios.costoEnvioKg') }}</th>
                  <th>{{ $t('pricing.mis_precios.costoTotalKg') }}</th>
                  <th>{{ $t('pricing.mis_precios.profitMin') }}</th>
                  <th>{{ $t('pricing.mis_precios.profitCal1') }}</th>
                  <th>{{ $t('pricing.mis_precios.profitCal2') }}</th>
                  <th>{{ $t('pricing.mis_precios.precioUser') }}</th>
                  <th>{{ $t('pricing.mis_precios.volAcu') }}</th>
                  <th>{{ $t('pricing.mis_precios.cif') }}</th>
                  <th>{{ $t('pricing.mis_precios.ok') }}</th>
                  <th>{{ $t('pricing.mis_precios.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td :colspan="9" class="spinner-cell">
                    <div class="spinner"></div>
                  </td>
                </tr>
                <tr v-for="(item, index) in selectedRfpItemsDetails" :key="index">
                  <td><input type="checkbox"
                    v-model="item.selected"
                    :checked="item.estado === 'aprobado'"
                    :disabled="item.estado === 'rechazado'"
                     />
                  </td>
                  <td>{{ item.sku_id }}</td>
                  <td>{{ item.sku_name }}</td>
                  <td>{{ item.precio_usd_kg }}</td>
                  <td>{{ item.precio_usd_caja }}</td>
                  <td>{{ item.costo_KG }}</td>
                  <td>{{ item.costo_envio }}</td>
                  <td>{{ item.costo_total_caja }}</td>
                  <td>{{ item.profit }} %</td>
                  <td>{{ item.profit_calculado_porcentaje }} %</td>
                  <td>{{ item.profit_calculado_usd_kg }}</td>
                  <td>{{ formatPrecioUsuario(item.precio_usuario) }}</td>
                  <td>{{ item.volumen }}</td>
                  <td>{{ item.CIF_Approx }}</td>
                  <td>
                    {{ item.estado === 'rechazado' ? '❌' : '✅' }}
                  </td>
                  <td>
                    <span
                      :class="{
                        tag: true,
                        'tag-pendiente': item.estado === 'pendiente',
                        'tag-aprobado': item.estado === 'aprobado',
                        'tag-rechazado': item.estado === 'rechazado'
                      }"
                    >
                      {{ item.estado ? item.estado.toUpperCase() : 'SIN ESTADO' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

            <div style="margin-top: 12px; margin-bottom: 8px;">
              <button v-if="!isVendor" class="btn-compare" :disabled="getSelectedItems().length === 0" @click="openCompareModal">
                Comparar
              </button>
            </div>

          <!-- Sección de Comentarios -->
          <div class="comments-section">
            <h4>{{ $t('pricing.mis_precios.comments') }}</h4>
              <div v-if="isLoading">
                <div class="spinner"></div>
              </div>
            <!-- Lista de comentarios -->
            <div v-if="this.comentarios">
              <div
                v-for="(comentario, index) in this.comentarios"
                :key="index"
                style="margin-bottom: 15px; border-bottom: 1px solid #e8e8e8;"
              >
                <b>
                  {{ comentario.perfil === 'vendor'
                    ? 'Creado por Vendor'
                    : `${comentario.state} por ${getPerfilNombre(comentario.perfil)}` }}
                </b>
                <div><b>{{ $t('pricing.mis_precios.comment') }}:</b> {{ comentario.comentario }}</div>
                <div><b>{{ $t('pricing.mis_precios.creationDate') }}:</b> {{ formatDate(comentario.creation_date) }}</div>
              </div>
            </div>
            <div v-else>
              <p></p>
            </div>

            <!-- Condición para mostrar el textarea -->
            <div v-if="canComent(selectedRfp)" class="form-group mt-3">
              <label for="comment">{{ $t('pricing.mis_precios.addComment') }}</label>
              <textarea
                v-model="nuevoComentario"
                class="form-control"
                style="resize: none;"
                maxlength="560"
                rows="5"
                id="comment"
                :placeholder="$t('pricing.mis_precios.commentPlaceholder')"
              ></textarea>
            </div>

          </div>

          <!-- Sección de Archivos Soporte -->
          <div class="comments-section">
            <h4>{{ $t('pricing.mis_precios.supportFiles') }}</h4>

            <div v-if="isLoading">
              <div class="spinner"></div>
            </div>

            <!-- Archivos disponibles -->
            <div v-if="files && files.length">
              <div
                v-for="(file, index) in files"
                :key="index"
                class="text-center mb-4"
                style="display: inline-block; width: 150px;"
              >
                <a :href="`${baseUrl}pricing/obtenerFile/?id=${file.id}`" target="_blank" style="text-decoration: none;">
                  <img
                    src="../../../assets/img/files-download.png"
                    alt="Descargar archivo"
                    style="width: 60px; cursor: pointer;"
                  />
                  <div style="margin-top: 8px; font-size: 14px; color: #333;">
                    {{ file.name }}
                  </div>
                </a>
              </div>
            </div>

            <!-- No hay archivos -->
            <div v-else-if="!isLoading">
              <p class="text-muted">{{ $t('pricing.mis_precios.noSupportFiles') }}.</p>

              <div v-if="canUpdateStatus(rfp)">
                <div class="mt-3 file-buttons">
                  <label class="btn-upload">
                    {{ $t('pricing.mis_precios.uploadFile') }}
                    <img src="@/assets/img/subir.png" alt="Subir archivo" style="width: 16px; height: 16px; margin-right: 5px;" />
                    <input
                      type="file"
                      class="hidden-file-input"
                      @change="handleFileUpload"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.eml,.msg"
                    />
                  </label>
                  <button class="btn-delete" @click="handleDeleteFile">
                    {{ $t('pricing.mis_precios.deleteFile') }}
                    <img src="@/assets/img/eliminar.png" alt="Eliminar archivo" style="width: 16px; height: 16px; margin-right: 5px;" />
                  </button>
                </div>

                <div v-if="selectedFile" class="mt-2">
                  <small class="text-muted">
                    {{ selectedFile.name }}
                  </small>
                </div>

                <div v-if="uploadSuccess" class="mt-2 text-success">
                  {{ $t('pricing.mis_precios.uploadedOk') }}
                </div>
                <div v-if="deleteSuccess" class="mt-2 text-success">
                  {{ $t('pricing.mis_precios.deletedOk') }}
                </div>
              </div>
            </div>
          </div>


          <!-- Modal Confirmacion -->
          <div v-if="showConfirmModal" class="modal-backdrop">
            <div class="modal-box">
              <h3>{{ $t('pricing.mis_precios.confirmTitle') }}</h3>
              <p>{{ $t('pricing.mis_precios.confirmNoSelection') }}<br>
                <span v-html="$t('pricing.mis_precios.confirmQuestion')"></span></p>
              <div class="modal-buttons">
                <button @click="handleModalDecision('approveAll')" class="btn btn-approve">{{ $t('pricing.mis_precios.confirmApproveAll') }}</button>
                <button @click="handleModalDecision('rejectAll')" class="btn btn-reject">{{ $t('pricing.mis_precios.confirmRejectAll') }}</button>
                <button @click="handleModalDecision('cancel')" class="btn btn-cancel">{{ $t('global.btn_cancel') }}</button>
              </div>
            </div>
          </div>

          <!-- Botónes -->
          <!-- Botones Aprobar y Rechazar -->
          <div v-if="this.approvedStatus" class="alert alert-success">
            {{ $t('pricing.mis_precios.approvedOk') }}
          </div>

          <div v-if="this.rejectedStatus" class="alert alert-danger">
            {{ $t('pricing.mis_precios.rejectedOk') }}
          </div>

          <div v-if="this.errorStatus" class="alert alert-danger">
            {{ this.errorStatus }}
          </div>

          <div v-if="canUpdateStatus() && !accionEnviada && !isLoading" class="approval-buttons">
            <div v-if="isLoadingStatus">
              <div class="spinner"></div>
            </div>
            <button v-if="!isLoadingStatus" class="btn-approve" @click="aprobarRfp(selectedRfp.idrfp)">
              <img src="@/assets/img/tickprice.png" alt="Aprobar" style="width: 30px; height: auto; margin-right: 5px;" />
              {{ $t('pricing.mis_precios.approve') }}
            </button>
            <button v-if="!isLoadingStatus" class="btn-reject" @click="rechazarRfp(selectedRfp.idrfp)">
              <img src="@/assets/img/rejectprice.png" alt="Rechazar" style="width: 16px; height: 16px; margin-right: 5px;" />
              {{ $t('pricing.mis_precios.reject') }}
            </button>
          </div>


          <div v-if="this.pricingProfile?.toLowerCase() === 'vendor'" class="reorder-button-container">
            <button class="reorder-button" @click="reorderItems">
              <img src="@/assets/img/refresh.png" alt="Enviar" style="width: 16px; height: 16px; margin-right: 5px;" /> Reorder
            </button>
          </div>

          <CompararSkuModal
            :visible="showCompareModal"
            :items="getSelectedItems()"
            :rfp="selectedRfp"
            @close="closeCompareModal"
          />

        </div>
      </div>
    </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CompararSkuModal from './CompararSkuModal.vue';
import { formatPrecioUsuario } from '@/assets/js/priceFormat';

export default {
  name: 'MisPreciosComponent',
  components: { CompararSkuModal },
  data() {
    return {
      allPrecios: [],
      precios: [],
      page: 1,
      limit: 10,
      totalItems: 0,
      isLoading: false,
      isLoadingStatus: false,
      isDownloading: false,
      pricingProfile: '',
      email: '',
      selectedRfp: null,
      selectedRfpItemsDetails: [],
      nuevoComentario: '',
      state_final: null,
      comentarios: [],
      files: [],
      selectAll: false,
      baseUrl: process.env.VUE_APP_BACKEND_API_URL,
      approvedStatus: false,
      rejectedStatus: false,
      errorStatus: '',
      accionEnviada: false,
      selectedFile: null,
      uploadSuccess: false,
      deleteSuccess: false,
      showConfirmModal: false,
      showCompareModal: false,
      pendingAccion: null,
      filterStartDate: '',
      filterEndDate: '',
      filterCreationDate: '',
      filterId: '',
      filterDistribuidor: '',
      filterNameDistribuidor: '',
      filterPlanta: '',
      filterEstado: '',
      filterProfit: '',
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.limit);
    },
    visiblePageNumbers() {
      const maxVisible = 10;
      const pages = [];

      let start = Math.max(this.page - Math.floor(maxVisible / 2), 1);
      let end = start + maxVisible - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisible + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
    uniqueEstados() {
      const labels = {
        pricing: 'PENDIENTE PRICING',
        sales: 'PENDIENTE SALES',
        finance: 'PENDIENTE FINANCE',
        final_approval: 'PENDIENTE FINAL APPROVAL',
        aprobado: 'APROBADO',
        parcial: 'PARCIAL',
        rechazado: 'RECHAZADO',
        vencido: 'VENCIDO'
      };

      return Object.entries(labels).map(([value, label]) => ({ value, label }));
    },
    uniqueProfits() {
      return ['VALID', 'INVALID'];
    }
    ,
    isVendor() {
      return (this.pricingProfile || '').toLowerCase() === 'vendor';
    },
    isPricingCoord() {
      return (this.pricingProfile || '').toLowerCase() === 'pricing_coord';
    }
  },
  methods: {
    formatPrecioUsuario,
    loadPricingProfile() {
      const rawProfile = sessionStorage.getItem('mccain_service_user_profile');
      if (rawProfile) {
        const parsedProfile = JSON.parse(rawProfile);
        const dynamicData = JSON.parse(parsedProfile.dynamicData);
        this.pricingProfile = dynamicData.Princing_profile;
      }
    },
    buildFiltros() {
      return {
        idrfp: this.filterId || '',
        id_distribuidor: this.filterDistribuidor || '',
        name_distribuidor: this.filterNameDistribuidor || '',
        planta: this.filterPlanta || '',
        start_date: this.filterStartDate || '',
        end_date: this.filterEndDate || '',
        creation_date: this.filterCreationDate || '',
        estado: this.filterEstado || '',
        state: this.filterProfit || '',
      };
    },
    async fetchPrecios() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.precios = [];
      try {
        this.loadPricingProfile();

        const response = await axios.post('/pricing/list', {
          filtros: this.buildFiltros(),
        });

        if (response.data.status) {
          this.allPrecios = response.data.items;
          this.filteredPrecios = this.allPrecios;
          this.totalItems = this.allPrecios.length;
          this.updatePaginatedPrecios();
        }
      } catch (error) {
        console.error('Error cargando precios:', error);
      } finally {
        this.isLoading = false;
      }
    },
    buscar() {
      this.page = 1;
      this.fetchPrecios();
    },
    async descargarPrecios() {
      if (this.isDownloading) return;
      this.isDownloading = true;
      try {
        const header = [
          'ID',
          this.$t('pricing.mis_precios.dist'),
          this.$t('pricing.mis_precios.ndist'),
          this.$t('pricing.mis_precios.plant'),
          this.$t('pricing.mis_precios.incoterm'),
          this.$t('pricing.mis_precios.codSap'),
          this.$t('pricing.mis_precios.sku'),
          this.$t('pricing.mis_precios.startDate'),
          this.$t('pricing.mis_precios.endDate'),
          this.$t('pricing.mis_precios.creationDate'),
          this.$t('pricing.mis_precios.priceCoordApprovalDate'),
          this.$t('pricing.mis_precios.precioUsdCaja'),
          this.$t('pricing.mis_precios.precioUsdKg'),
          this.$t('pricing.mis_precios.profitCal2'),
          this.$t('pricing.mis_precios.state'),
        ];

        const response = await axios.post('/pricing/downloadPricesList', {
          filtros: this.buildFiltros(),
          history_title: this.$t('pricing.mis_precios.title'),
          header,
        }, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'mis_precios.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al descargar mis precios:', error);
      } finally {
        this.isDownloading = false;
      }
    },
    resetFilters() {
      this.filterId = '';
      this.filterDistribuidor = '';
      this.filterNameDistribuidor = '';
      this.filterPlanta = '';
      this.filterStartDate = '';
      this.filterEndDate = '';
      this.filterCreationDate = '';
      this.filterEstado = '';
      this.filterProfit = '';
      this.buscar();
    },
    updatePaginatedPrecios() {
      const start = (this.page - 1) * this.limit;
      const end = start + this.limit;
      this.precios = this.filteredPrecios.slice(start, end);
    },
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.page = newPage;
        this.updatePaginatedPrecios();
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    toggleAll() {
      this.selectedRfpItemsDetails.forEach(item => {
        item.selected = this.selectAll && item.estado != 'rechazado';
      });
    },
    getSelectedItems() {
      return Array.isArray(this.selectedRfpItemsDetails)
        ? this.selectedRfpItemsDetails.filter(i => i.selected)
        : [];
    },
    openCompareModal() {
      this.showCompareModal = true;
    },
    closeCompareModal() {
      this.showCompareModal = false;
    },
    async openModalWithDetails(item) {
      this.isLoading = true;
      this.selectedRfp = item;
      
      try {
        const response = await axios.get('/pricing/getDetails', {
          params: { id: item.idrfp }
        });

        if (response.data) {
          this.selectedRfpItemsDetails = response.data.details.map(item => ({
            ...item,
            selected: item.estado === 'aprobado'
          }));
          this.getComents();
          this.getStateFinal();
          this.getFiles();
          this.canComent(this.selectedRfpItemsDetails);
          this.showModal = true;
        }
      } catch (error) {
        console.error('Error al obtener los detalles del RFP:', error);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.selectedRfp = null;
          if (this.selectedRfpItemsDetails) {
        this.selectedRfpItemsDetails.forEach(item => {
          item.selected = false;
        });
      }
      this.selectedRfpItemsDetails = null;
      this.comentarios = null;
      this.files = null;
      this.selectAll = false;
      this.showCompareModal = false;
      this.nuevoComentario = '';
      this.selectedFile = null;
      this.state_final = null;
      this.approvedStatus = false;
      this.rejectedStatus = false;
      this.errorStatus = '';
      this.accionEnviada = false;
    },
    async getComents() {
      this.isLoading = true;
      try {
        const response = await axios.get('/pricing/getComents', {
          params: { idrfp: this.selectedRfp.idrfp }
        });
        this.comentarios = response.data.coments || [];
      } catch (error) {
        console.error('Error al obtener comentarios:', error);
      } finally {
        this.isLoading = false;
      }
    },
    getPerfilNombre(perfil) {
      const perfiles = {
        sales_dir: 'Director de Ventas',
        finance_coord: 'Coordinador de Finanzas',
        pricing_coord: 'Coordinador de Precios',
        vendor: 'Vendor',
        pricing_final_approval: 'Final Approval'
      };
      return perfiles[perfil] || perfil;
    },
    async getFiles() {
      this.isLoading = true;
      try {
        const response = await axios.get('/pricing/getFile', {
          params: { idrfp: this.selectedRfp.idrfp }
        });
        this.files = response.data.files || [];
      } catch (error) {
        console.error('Error al obtener archivos:', error);
      } finally {
        this.isLoading = false;
      }
    },
    isImage(type) {
      return type === 'image/png' || type === 'image/jpeg';
    },
    downloadFile(url, filename) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'archivo');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getStateFinal() {
      const rfp = this.selectedRfp;
      if (!rfp) return null;

      const aprobadoFinal = rfp.aprobado_final_approval === "true";
      const rechazado =
        rfp.aprobado_sales_dir === "false" ||
        rfp.aprobado_finance_coord === "false" ||
        rfp.aprobado_price_coord === "false" ||
        rfp.aprobado_final_approval === "false";
      const pendiente =
        rfp.aprobado_sales_dir === "true" ||
        rfp.aprobado_finance_coord === "true" ||
        rfp.aprobado_price_coord === "true";

      if (aprobadoFinal) return this.state_final = "APROBADO";
      else if (rechazado) return this.state_final = "RECHAZADA";
      else if (pendiente) return this.state_final = "PENDIENTE";
      else return this.state_final = rfp.state || null;
    },
    canComent(rfp) {
      const perfil = this.pricingProfile?.toLowerCase();
      const estado = this.state_final;
      if (perfil === 'vendor') return false;
      if (!rfp) return false;

      if (estado === 'APROBADO' || estado === 'RECHAZADA') return false;

      if (estado === "PENDIENTE") {
        if (
          (perfil === "sales_dir" && rfp.aprobado_sales_dir === "true") ||
          (perfil === "finance_coord" && rfp.aprobado_finance_coord === "true")||
          (perfil === "pricing_coord" && rfp.aprobado_price_coord === "true")||
          (perfil === "pricing_final_approval" && rfp.aprobado_final_approval === "true")
        ) {
          return false;
        }
      }
      return true;
    },
    canUpdateStatus() {
      const perfil = this.pricingProfile?.toLowerCase();
      const estado = this.state_final;
      const aprobadoSalesDir = this.selectedRfp?.aprobado_sales_dir;
      const aprobadoFinanceCoord = this.selectedRfp?.aprobado_finance_coord;
      const aprobadoPriceCoord = this.selectedRfp?.aprobado_price_coord;
      const aprobadoFinalApproval = this.selectedRfp?.aprobado_final_approval;

      if (perfil === 'vendor') {
        return false;
      }

      if (estado === 'APROBADO' || estado === 'RECHAZADA') {
        return false;
      }

      if (estado === 'PENDIENTE' || estado === 'VALID' || estado === 'INVALID') {
        if (
          (perfil === 'sales_dir' && aprobadoSalesDir === 'true') ||
          (perfil === 'finance_coord' && aprobadoFinanceCoord === 'true') ||
          (perfil === 'pricing_coord' && aprobadoPriceCoord === 'true') ||
          (perfil === 'pricing_final_approval' && aprobadoFinalApproval === 'true')
        ) {
          return false;
        }
      }

      return true;
    },
    aprobarRfp() {
      this.actualizarEstadoRfp("approve");
    },
    rechazarRfp() {
      this.actualizarEstadoRfp("reject");
    },
    handleModalDecision(decision) {
      this.showConfirmModal = false;

      if (decision === 'cancel') return;

      const accion = decision === 'approveAll' ? 'approve' : 'reject';
      this.actualizarEstadoRfp(accion, true);
    },
    actualizarEstadoRfp(accion, forzarTodos = false) {
      // Block resubmissions: once the action is sent it cannot run again until reload
      if (this.accionEnviada || this.isLoadingStatus) return;
      this.errorStatus = '';

      const rawProfile = sessionStorage.getItem('mccain_service_user_profile');
      if (rawProfile) {
        const parsedProfile = JSON.parse(rawProfile);
        const dynamicData = JSON.parse(parsedProfile.dynamicData);
        this.email = dynamicData.email;
      }

      let selectedItems = this.selectedRfpItemsDetails.filter(item => item.selected);
      if (selectedItems.length === 0 && !forzarTodos) {
        this.pendingAccion = accion;
        this.showConfirmModal = true;
        return;
      }
   
      if (forzarTodos) {
        selectedItems = [...this.selectedRfpItemsDetails];
      }

      this.isLoadingStatus = true;
      let request;
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append("idrfp", this.selectedRfp.idrfp);
        formData.append("comentario", this.nuevoComentario);
        formData.append("pricingProfile", this.pricingProfile);
        formData.append("email", this.email);
        formData.append("accion", accion);
        selectedItems.forEach(item => {
          formData.append("selectedItems[]", item.idrfp_items);
        });
        formData.append("totalItems", selectedItems.length);
        formData.append("file", this.selectedFile);

        request = axios.post("pricing/updateRfp", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

      }
      else {
        const payload = {
          idrfp: this.selectedRfp.idrfp,
          comentario: this.nuevoComentario,
          pricingProfile: this.pricingProfile,
          email: this.email,
          accion: accion,
          selectedItems: selectedItems,
          totalItems: selectedItems.length,
        };

        request = axios.post("pricing/updateRfp", payload);
      }
      request
        .then(response => {
          this.accionEnviada = true;
          if (accion === 'approve') {
            this.approvedStatus = true;
          } else {
            this.rejectedStatus = true;
          }
          console.log("Respuesta:", response.data);

          setTimeout(() => {
            this.approvedStatus = false;
            this.rejectedStatus = false;
            this.closeModal();
            window.location.reload();
          }, 2000);
        })
        .catch(error => {
          console.error("Error al actualizar el estado del RFP:", error);
          // The request may have persisted the change before failing: block retries instead of duplicating it
          this.accionEnviada = true;
          this.errorStatus = this.$t('pricing.mis_precios.actionError');
        })
        .finally(() => {
          this.isLoadingStatus = false;
        });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.selectedFile = file;
      this.uploadSuccess = true;
      setTimeout(() => {
        this.uploadSuccess = false;
      }, 2000);
    },
    handleDeleteFile() {
      if (!this.selectedFile) return;
      this.selectedFile = null;
      this.deleteSuccess = true;
      setTimeout(() => {
        this.deleteSuccess = false;
      }, 2000);
    },
    reorderItems() {
      const selectedItems = this.selectedRfpItemsDetails;
      const selectedRfp = this.selectedRfp;
      if (selectedItems.length === 0) return;

      sessionStorage.setItem('reorderData', JSON.stringify(selectedItems));
      sessionStorage.setItem('reorderDataRfp', JSON.stringify(selectedRfp));
      this.$router.push({ name: 'pricing-nuevo-precio' });
    },
    abrirCalendario() {
      const input = this.$refs.inputFechaInicio;
      if (input.showPicker) {
        input.showPicker();
      } else {
        input.click();
      }
    },
    abrirCalendarioFin() {
      const input = this.$refs.inputFechaFin;
      if (input?.showPicker) {
        input.showPicker();
      } else {
        input.click();
      }
    },
    abrirCalendarioCreacion() {
      const input = this.$refs.inputFechaCreacion;
      if (input?.showPicker) {
        input.showPicker();
      } else {
        input.click();
      }
    },
    getEstadoLabel(estado) {
      switch (estado) {
        case 'pricing': return 'PENDIENTE PRICING';
        case 'sales': return 'PENDIENTE SALES';
        case 'finance': return 'PENDIENTE FINANCE';
        case 'final_approval': return 'PENDIENTE FINAL APPROVAL';
        case 'aprobado': return 'APROBADO';
        case 'vencido': return 'VENCIDO';
        case 'parcial': return 'PARCIAL';
        case 'rechazado': return 'RECHAZADO';
        default: return estado;
      }
    }
  },
  mounted() {
    this.fetchPrecios();
  }
};
</script>

<style scoped>
.mis-precios .container {
  padding: 20px;
}

.title-with-back {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-arrow {
  text-decoration: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

.back-arrow:hover {
  color: #000;
}

.table-section {
  margin-top: 20px;
}

.spinner-cell {
  text-align: center;
  padding: 20px;
}

.spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.prices-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 2rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.prices-table thead {
  background-color: #f5f7fa;
  color: #333;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

.prices-table th,
.prices-table td {
  padding: 12px 15px;
  text-align: center;
  border-bottom: 1px solid #e1e7ec;
}

.prices-table tbody tr:hover {
  background-color: #f0f4f8;
  transition: background-color 0.2s ease-in-out;
}

.prices-table tbody tr:last-child td {
  border-bottom: none;
}

.state-valid {
  color: #28a745;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.state-invalid {
  color: #dc3545;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.state-icon {
  font-size: 1.1em;
}



.tag {
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  color: #fff;
  display: inline-block;
  min-width: 140px;
  text-align: center;
}

.tag-pricing,
.tag-sales,
.tag-finance,
.tag-final {
  background-color: #f0a500;
  color: #fff;
}

.tag-aprobado,
.tag-parcial {
  background-color: #58c792;
  color: #fff;
}

.tag-rechazado {
  background-color: #e74c3c;
  color: #fff;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.close-button-container .close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 30px;
  font-weight: bold;
  color: #888;
  cursor: pointer;
  transition: color 0.2s ease;
}

.close-button-container .close-button:hover {
  color: #000;
}

.modal-content h2 {
  margin-bottom: 1rem;
}

.modal-content ul {
  list-style: none;
  padding: 0;
  margin-bottom: 1rem;
}

.modal-content button {
  background-color: #007bff;
  border: none;
  padding: 8px 16px;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}

.modal-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
}
.modal-box {
  background: #fff;
  padding: 20px 30px;
  border-radius: 8px;
  width: auto;
  max-width: 90%;
  text-align: center;
}
.modal-buttons {
  margin-top: 20px;
  display: flex;
  gap: 30px;
  justify-content: space-between;
}

.modal-buttons .btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}
.modal-buttons .btn-approve { background-color: #28a745; color: white; }
.modal-buttons .btn-reject { background-color: #dc3545; color: white; }
.modal-buttons .btn-cancel { background-color: #6c757d; color: white; }

.comments-section {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  margin-top: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.comments-section h4 {
  margin-bottom: 10px;
  color: #333;
}

.comments-section ul {
  list-style: none;
  padding: 0;
}

.comments-section li {
  margin-bottom: 8px;
}

.reorder-button-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.reorder-button-container .reorder-button {
  background-color: #008d06;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
  margin-bottom: 10px;
}

.reorder-button:hover {
  background-color: #00cb08;
}

.modal-product-table-container {
  overflow-x: auto;
  overflow-y: hidden !important;
  margin-top: 20px;
  flex-shrink: 0;
}

.modal-product-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modal-product-table th,
.modal-product-table td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
}

.modal-product-table th {
  background-color: #f5f7fa;
  color: #333;
  font-weight: 600;
}

.modal-product-table td {
  color: #555;
}

.modal-product-table input[type="checkbox"] {
  transform: scale(1.1);
  cursor: pointer;
}

.tag.tag-pendiente {
  background-color: #ffecb3;
  color: #b36b00;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.approval-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
}

.approval-buttons
.btn-approve,
.btn-reject {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  transition: background-color 0.3s ease;
}

.approval-buttons .btn-approve {
  background-color: #28a745;
}

.approval-buttons .btn-approve:hover {
  background-color: #218838;
}

.approval-buttons .btn-reject {
  background-color: #dc3545;
}

.approval-buttons .btn-reject:hover {
  background-color: #c82333;
}

.file-buttons {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 1rem;
}

.btn-upload {
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.hidden-file-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.file-buttons .btn-delete {
  background-color: #dc3545;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}

.table-responsive {
  overflow-x: auto;
}

.prices-table {
  width: 100%;
  border-collapse: collapse;
}

.btn-compare {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease, opacity 0.15s ease, transform 0.05s ease;
}

.btn-compare:not(:disabled):hover {
  background-color: #0056b3;
}

.btn-compare:disabled {
  background-color: #c0c4c8;
  color: #ffffff;
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

</style>
